import { render, staticRenderFns } from "./PhoCheckbox.vue?vue&type=template&id=b00b626a&lang=pug"
import script from "./PhoCheckbox.vue?vue&type=script&lang=js"
export * from "./PhoCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports